import moment from "moment";
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import DateFormatEnum from "~/enums/DateFormatEnum";

const initialTaskForm = {
  id: null,
  priority: 2,
  customer_id: null,
  type: 20,
  date: moment().format(DateFormatEnum.DATE),
  category_id: null,
  user_id: null,
  instance_id: null,
  instance_type: null,
  assigned_departments: [],
  productLabels: [],
  assigned_users: [],
  template: null,
  status: 0,
  content: "",
  description: "",
  visible_for_customer: false,
  create_note: false,
};

const state = {
  category: null,
  type: null,
  departments: [],
  categories: [],
  productLabels: [],
  users: [],
  types: [],
  templates: [],
  errors: {},
  axiosError: null,
  loading: true,
  initialTaskForm,
  task: initialTaskForm,
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
